// components/PageNavigation.js
import React from 'react';
import { usePageControl } from '../context/PageControlContext';

const PageNavigation = () => {

  const {
    goNext,
    goBack,
    canGoBack,
    canContinue
  } = usePageControl();

  return (
    <div className="page-navigation">

      {canGoBack && (
        <button
          className="btn btn-page-nav btn-back"
          onClick={goBack}
        >
          Back
        </button>
      )}

      {canContinue && (
        <button
          className="btn btn-page-nav btn-continue btn-pulse"
          onClick={goNext}
        >
          Continue
        </button>
      )}

    </div>
  );
};

export default PageNavigation;